<template>
<div v-if="isShow">
    <!-- Register 2 - input phone number -->
    <div>
        <header>新規登録<div class="h-left"><a @click="$emit('close')"><img src="~@/assets/images/icon02.svg"></a></div>
        </header>
        <div id="wrap">
            <div class="txt-area">
                <p>次に、あなたがロボットや業者でないことを証明するために電話番号を入力してください。</p>
            </div>
            <div class="cp_iptxt">
                <input type="text" name="phone" placeholder="携帯電話番号" maxlength="11" v-model="formData.phone" autocomplete="off">
                <i class="fas fa-mobile-alt fa-lg fa-fw" aria-hidden="true"></i>
            </div>
            <p class="login-4">SMSを受け取ることができる携帯電話番号を入力してください</p>

            <div :class="checkPhone() ? 'btn1' : 'btn3'" id="btn_input_phone"><a @click="submit()">次へ</a></div>

        </div>
    </div>
</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import {
    getToken
} from '@/auth'
export default {
    props: {
        isShow: Boolean,
        isVerifyPhone: Boolean
    },
    emits: ['close'],
    data: () => ({
        formData: {
            phone: null
        },
    }),
    mounted() {},
    watch: {
        isVerifyPhone(val) {
            if (val) {
                this.isShowVerifyPhone = true
            }
        }
    },

    computed: {
        ...mapGetters([
            "defaultToken", "userDetail"
        ])
    },
    methods: {
        checkPhone() {
            if (this.formData.phone) {
                this.formData.phone = this.formData.phone.replace(/\D/g,'');
            }
            if (this.formData.phone && this.formData.phone.length === 11) {
                return true
            } else false
        },
        async submit() {
            if (this.checkPhone()) {
                this.$store.dispatch("route/showLoading")
                
                await this.$store.dispatch('register/getSMSCode', {
                    phone_number: this.formData.phone,
                    token: getToken()
                }).then(data => {
                    this.$emit('submit', this.formData.phone)
                }).catch(err => {
                    this.$emit('close')
                    console.log(err)
                })
                
                this.$store.dispatch("route/hideLoading")
            }
        },
    }
}
</script>
